import { render, staticRenderFns } from "./purmrobudge.vue?vue&type=template&id=37af9018&scoped=true&"
import script from "./purmrobudge.vue?vue&type=script&lang=js&"
export * from "./purmrobudge.vue?vue&type=script&lang=js&"
import style0 from "./purmrobudge.vue?vue&type=style&index=0&id=37af9018&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37af9018",
  null
  
)

export default component.exports